var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlasmaRifleVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.2524 28.0576L26.4389 22.7086L24.7049 22.1461C24.7049 22.1461 23.5574 19.5976 23.6249 17.9221C23.6924 16.2466 24.0944 14.3521 24.7049 13.6981C25.3154 13.0441 29.0969 10.5721 29.0969 10.5721C29.0969 10.5721 29.3504 8.51707 30.8279 7.51657L32.3054 6.51757L45.3134 4.20757C45.3134 4.20757 51.8699 3.27607 53.9114 3.15907C55.9529 3.04207 68.1284 2.56357 81.4289 4.62607C81.4289 4.62607 83.7629 5.37457 84.3389 6.43507C84.9149 7.49557 85.3949 8.37757 85.3949 8.37757L91.1804 9.81307L95.6594 10.2781L97.0919 9.72907C97.0919 9.72907 98.6129 10.0666 99.3719 9.89857C100.131 9.73057 101.23 9.31357 101.23 9.31357L103.342 11.9266V13.7851L101.031 14.8246L99.3719 15.5461L87.4619 16.7416L86.7014 17.5861L74.7914 18.4306L74.5379 19.4446L70.1474 20.0671C70.1474 20.0671 67.2554 21.3511 67.4429 22.4011C67.6304 23.4511 68.1869 25.0666 68.1869 25.0666L69.2174 25.9756L70.5689 26.5396L70.9919 30.7636L69.8099 31.6921L69.6404 33.9721L67.9049 35.2006L67.5014 36.1681L67.4429 37.6036L69.2174 39.0391C69.2174 39.0391 70.1774 38.7106 71.3804 39.2266C72.5834 39.7426 76.5659 41.7421 76.5659 41.7421L77.4104 44.0221L92.4464 48.3301L90.4199 51.2026L88.5299 51.8941L91.7714 52.8916L92.4464 54.2431L90.9584 55.0231L84.0059 53.5396L81.3809 54.3271L74.5259 52.5316C74.5259 52.5316 72.6059 54.5356 71.7989 55.0216C70.9904 55.5076 70.1474 55.8466 70.1474 55.8466C70.1474 55.8466 56.1089 55.5961 49.8749 55.0531C43.6394 54.5101 38.4434 53.9881 37.6559 53.6506C36.8669 53.3131 34.0259 51.7771 32.4614 50.6131C30.8969 49.4491 28.5899 47.7376 28.5899 47.7376C28.5899 47.7376 25.5254 47.0866 24.7634 44.9566C24.0014 42.8266 23.7674 39.6361 23.8409 39.2236C23.9144 38.8111 24.6644 37.3786 24.6644 37.3786L25.9184 35.6761L26.2814 33.8011L27.1829 33.4636L27.9719 31.3801L30.3869 31.4536L31.1549 33.4636L31.9154 37.0111L35.2379 37.1236L36.0269 36.1666L38.2229 36.1096L38.7329 36.6841L40.1369 36.7291L41.3369 38.8411L43.0649 39.7126L49.8779 35.5126C49.8779 35.5126 51.4949 34.4566 52.3559 34.7011C53.2169 34.9456 54.4874 36.1501 55.5089 36.5026C56.5304 36.8566 57.6059 36.9676 58.6619 36.8401C59.7179 36.7126 60.7469 35.6746 60.7469 35.6746L61.2749 33.9721C61.2749 33.9721 62.5874 33.9151 63.0464 33.2371C63.5054 32.5591 63.5549 31.3771 63.5549 31.3771L62.6189 30.3361L61.5179 29.7151L61.4789 29.1031C61.4789 29.1031 62.8484 27.6601 62.2679 26.9281C61.6874 26.1961 60.6914 25.7236 59.2829 25.7071C57.8744 25.6906 57.0839 25.4656 56.8049 25.0696C56.5259 24.6736 54.8909 22.7041 54.8909 22.7041L49.8794 21.8191L44.8679 20.9581H41.8274L41.3774 22.7041L36.2534 23.2666L35.6339 22.3081L32.8184 22.3126C32.8184 22.3126 31.9034 22.5931 31.9394 23.3251C31.9754 24.0571 31.9739 25.7446 31.9739 25.7446L31.1294 25.8571L29.9474 28.0531H28.2584L28.2524 28.0576Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7158 36.7156C59.7158 36.7156 61.6583 38.9116 63.1793 38.4466C64.7003 37.9816 65.9663 36.9256 66.2198 36.3766C66.4733 35.8276 68.1203 33.3361 68.3738 33.1246C68.6273 32.9131 69.7238 32.8411 69.7238 32.8411",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9014 22.089C57.9014 22.089 63.0104 21.4695 64.7219 23.4405C66.4334 25.4115 66.2069 25.806 66.7139 25.6935C67.2209 25.581 68.1899 25.065 68.1899 25.065",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.083 22.7086C57.083 22.7086 58.1525 24.2296 58.7165 24.5101C59.279 24.7921 62.333 23.6656 64.721 26.2561C64.721 26.2561 66.7745 26.8906 67.082 29.1076C67.3895 31.3246 65.249 32.3386 65.249 32.3386C65.249 32.3386 65.5865 33.0706 65.1365 33.8026C64.6865 34.5346 63.335 34.1971 62.969 34.7596C62.603 35.3221 62.828 35.7166 62.378 36.3361C61.928 36.9556 60.4055 37.3816 60.4055 37.3816",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.082 29.1076L70.805 28.8871",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8867 13.6426L61.8717 10.5736H70.8072C70.8072 10.5736 71.8392 11.9251 72.5712 12.1081C73.3032 12.2911 76.7382 12.1081 76.7382 12.1081L77.6397 10.9966L81.8067 11.1376L82.3692 12.3481H86.5932H82.3692L76.7382 12.1081",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9049 13.6426C47.9049 13.6426 47.4549 14.6281 47.2854 15.1636C47.1159 15.6991 46.7229 17.1631 46.7229 17.1631L47.1729 18.2611H47.9049L48.3834 17.1631L47.2854 15.1636",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2269 13.6426C50.2269 13.6426 49.7769 14.6281 49.6074 15.1636C49.4379 15.6991 49.0449 17.1631 49.0449 17.1631L49.4949 18.2611H50.2269L50.7054 17.1631L49.6074 15.1636",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5504 13.6426C52.5504 13.6426 52.1004 14.6281 51.9309 15.1636C51.7614 15.6991 51.3684 17.1631 51.3684 17.1631L51.8184 18.2611H52.5504L53.0289 17.1631L51.9309 15.1636",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8724 13.6426C54.8724 13.6426 54.4224 14.6281 54.2529 15.1636C54.0834 15.6991 53.6904 17.1631 53.6904 17.1631L54.1404 18.2611H54.8724L55.3509 17.1631L54.2529 15.1636",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1947 13.6427C57.1947 13.6427 56.7447 14.6282 56.5752 15.1637C56.4057 15.6992 56.0127 17.1632 56.0127 17.1632L56.4627 18.2612H57.1947L57.6732 17.1632L56.5752 15.1637",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0814 19.2241L46.7229 20.3431",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1644 19.2241L50.8059 20.3431",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0287 19.2241L52.6687 20.3431",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0675 19.2241L54.709 20.3431",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0216 19.224L56.6631 20.343",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0448 19.2241L48.6863 20.3431",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1869 13.6426C48.1869 13.6426 47.7639 11.2486 49.5669 11.2216C51.3684 11.1931 55.0674 11.2096 55.0674 11.2096C55.0674 11.2096 56.6094 11.1091 56.6634 12.6016C56.7174 14.0941 56.6634 13.6441 56.6634 13.6441",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3984 19.1671V20.9626",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4008 19.5646V20.9626L39.2053 21.1591L38.4463 19.9546",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3066 16.485L32.9546 17.274",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8828 17.2741L34.7273 16.4851",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6863 18.2596L34.3058 18.8506",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8129 18.2596L32.1094 18.8506",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0082 38.2437L52.7103 36.7304C52.1735 36.484 51.5386 36.7195 51.2922 37.2563L51.2916 37.2577C51.0452 37.7945 51.2807 38.4294 51.8176 38.6758L55.1154 40.1892C55.6523 40.4355 56.2872 40.2 56.5335 39.6632L56.5341 39.6618C56.7805 39.125 56.545 38.4901 56.0082 38.2437Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3145 40.3051C45.3145 40.3051 45.4195 43.1521 46.5235 45.2191C46.921 45.9631 47.4475 46.6066 48.1435 46.9786C50.7775 48.3871 60.238 49.0051 62.434 49.1191C64.63 49.2316 73.3119 49.1446 76.7424 49.6111",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5229 45.2191C46.5229 45.2191 46.4404 45.4576 45.3139 46.1341C44.1874 46.8106 43.4554 47.8801 39.9649 48.1051C36.4729 48.3301 33.8839 48.1051 33.8839 48.1051L33.2089 48.6676L28.2529 47.4856",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1959 46.9441C27.1959 46.9441 25.3239 44.0506 26.1114 41.5726C26.8989 39.0946 26.5569 40.8406 26.5569 40.8406L28.2519 40.6711L28.5339 39.6571L26.9004 38.4586",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4462 36.6752L37.6572 38.4587L38.4462 40.3052",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6571 38.4586H32.8136L32.3066 39.2251",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M69.22 39.0391L70.8055 41.4031L76.5685 41.7421",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8057 41.4032L69.7257 44.2202L64.2012 43.6472",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7292 47.5186L91.8457 48.1576",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7224 48.3721L78.0039 49.8091",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8986 48.6705L79.3916 49.683",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0579 48.7801L80.6604 49.5736",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7256 44.2201L77.4131 44.0221",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3739 9.89709C99.3739 9.89709 92.7004 12.0556 92.1094 12.4546C91.5184 12.8536 90.7579 13.6411 90.7579 13.6411H87.9424",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5289 52.5331L81.3839 54.3286L83.4959 53.4316L91.2674 55.0891L92.4494 54.2446L91.7744 52.8931L87.3824 51.5416L90.4229 51.2041L92.4494 48.3316L77.4134 44.0236L76.5689 41.7436C76.5689 41.7436 71.6699 39.1246 70.7399 39.0406C69.8114 38.9566 69.2189 39.0406 69.2189 39.0406L67.4444 37.6051V35.7466L68.3729 34.6486L69.6404 33.9736L69.8099 31.6936L70.9919 30.7651L70.5689 26.5411C70.5689 26.5411 68.7104 25.8661 68.5424 25.5271C68.3744 25.1881 67.8674 24.7666 67.8674 24.7666L67.4444 22.4011C67.4444 22.4011 68.3729 20.5426 69.5564 20.2051C70.7399 19.8676 74.5394 19.4446 74.5394 19.4446L74.7929 18.4306L86.7029 17.5861L87.4634 16.7416C87.4634 16.7416 97.8524 15.8131 99.6269 15.3061C101.401 14.7991 103.344 13.7851 103.344 13.7851V11.9266L102.33 10.4056L101.232 9.31357C101.232 9.31357 99.8804 9.89857 99.3734 9.89857C98.8664 9.89857 97.0934 9.72907 97.0934 9.72907L96.3329 10.3201C96.3329 10.3201 91.9409 10.0666 91.1804 9.81307C90.4199 9.55957 85.3949 8.37757 85.3949 8.37757L84.3389 6.43507C84.3389 6.43507 83.6639 4.91407 80.7074 4.49257C77.7509 4.06957 63.6449 2.71807 55.6199 3.05707C47.5949 3.39457 32.3069 6.52057 32.3069 6.52057C32.3069 6.52057 29.9414 7.36507 29.0969 10.5751C29.0969 10.5751 26.3099 11.7571 24.7049 13.7011C23.0999 15.6436 23.4374 19.2766 24.7049 22.1476L26.2814 22.3171L27.5204 25.4146L28.2524 28.0606H29.9414L31.1234 25.8646L31.9679 25.7521V23.8381C31.9679 23.8381 31.6304 22.2616 32.9819 22.3171C34.3334 22.3726 35.6279 22.3171 35.6279 22.3171L36.2474 23.2756L41.5964 22.7686L41.8214 20.9671H44.5244C44.5244 20.9671 54.4919 22.5436 54.8864 22.7131C55.2809 22.8826 56.8004 25.0786 56.8004 25.0786C56.8004 25.0786 56.9129 25.5856 57.8699 25.6981C58.8269 25.8106 61.4174 25.1356 62.2619 26.9371C62.8589 28.2121 61.4729 29.1121 61.4729 29.1121L61.5299 30.0046C61.5299 30.0046 64.1984 30.3001 63.5009 32.5681C63.1949 33.5611 62.1494 33.6376 61.2479 33.7501C61.2479 33.7501 61.4654 34.8196 60.5789 35.8966C60.0974 36.4816 59.5019 36.6781 58.6574 36.8476C58.6574 36.8476 56.8559 37.2421 55.5044 36.5101C54.1529 35.7781 53.7029 34.8766 52.3514 34.7086C50.9999 34.5406 49.7609 35.6101 49.7609 35.6101L43.0604 39.7216L41.5394 39.2146L40.1309 36.7366L38.3849 36.6796L38.2154 36.1171L36.0194 36.1741L35.2304 37.1311L31.9079 37.0186L31.2329 32.9641L30.2759 31.2751L27.9674 31.3876L27.1784 33.4711L26.2769 33.8086C26.2769 33.8086 25.4879 36.6241 25.0949 36.7936C24.7004 36.9631 24.4754 37.9756 24.4754 37.9756C24.4754 37.9756 24.1379 38.0326 23.9129 38.8201C23.8649 38.9881 23.7959 39.4411 23.7719 40.0591C23.6834 42.3406 24.2009 46.8811 28.5869 47.7451L34.4999 52.1371C34.4999 52.1371 36.2744 53.5726 39.8219 54.0796C43.3694 54.5866 57.6449 55.9381 70.1459 55.8541C70.1459 55.8541 73.6094 55.1791 78.0014 47.5756L65.6684 45.2956C65.6684 45.2956 64.5704 43.7746 63.9794 43.5211C63.3884 43.2676 45.3119 40.3111 45.3119 40.3111L44.6369 41.6626L26.6459 38.1151C26.6459 38.1151 26.7299 40.3951 26.0549 41.1556C25.3799 41.9161 23.8124 42.5881 23.7944 41.3236",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9417 28.0577L30.8297 29.4272L30.2806 31.2677",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2525 28.0577L27.1965 29.6627L27.972 31.3802",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6279 17.1332C23.6279 17.1332 24.5369 15.6692 25.4384 17.7527C26.3399 19.8362 27.7259 22.0892 27.7259 22.0892L44.6969 18.7112C44.6969 18.7112 44.1899 15.3332 46.1609 13.6427C46.1609 13.6427 43.7954 11.6717 42.6689 11.2772C41.5424 10.8827 33.2084 10.2632 33.2084 10.2632C33.2084 10.2632 33.6584 6.49065 32.3069 6.51915",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0967 10.5736C29.0967 10.5736 30.8907 10.0786 33.2082 10.2646",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1592 13.6426H58.8852L60.9117 17.5276C60.9117 17.5276 69.8652 17.4706 72.0612 17.1901C74.2572 16.9081 86.9277 15.0496 86.9277 15.0496C86.9277 15.0496 87.8847 14.2051 87.9417 13.6411C87.9987 13.0771 87.2097 12.3466 86.5902 12.3466C86.5902 12.3466 87.5532 11.8396 87.9447 11.2201C88.3362 10.6006 86.6517 8.67306 86.0232 8.52456",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9132 17.5277L57.9012 22.0892H56.8032L54.8877 22.7087",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4785 51.3781L80.2005 50.7796L81.552 51.3781L84.678 51.0781L87.381 51.5401",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasmaRifleVariant);
export default __webpack_public_path__ + "static/media/Plasma Rifle Variant.9a3f4f8a9d5cab1ada6e878b7e2cffdc.svg";
export { ForwardRef as ReactComponent };